import axios from "axios";
import routes from "../routes";

export const auth = {
 register: async (postBody) => {
  return await axios.post(routes.register(), postBody);
 },
 signUp: async (postBody) => {
  return await axios.post(routes["sign-up"](), postBody)
 },
 verifySignUp: async (postBody) => {
  return await axios.post(routes["verify-sign-up"](),postBody)
 },
 signIn: async (postBody)=>{
  return await axios.post(routes["sign-in"](),postBody)
 },
 verifySignIn: async(postBody)=>{
  return await axios.post(routes["verify-sign-in"](),postBody)
 },
 login: async (postBody) => {
  return await axios.post(routes.login(), postBody);
 },
 adminLogin: async (postBody) => {
  return await axios.post(routes["admin-login"](), postBody);
 },
 changePassword: async (postBody) => {
  return await axios.post(routes["change-password"](), postBody)
 },
};
